const fileCache = new Map();

export const saveFileBlob = (id, blob) => {
  fileCache.set(id, blob);
};

export const getFileBlob = (id) => fileCache.get(id);

export const removeFileBlob = (id) => {
  fileCache.delete(id);
};

export const downloadFile = (fileId, fileName) => {
  const blob = getFileBlob(fileId);
  if (!blob) return;

  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};
